"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('ad-product', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M4 14L24 4L34 9L44 14V34L24 44L4 34V14Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14L14 19L24 24L44 14",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24V44V24Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M4 14L3.10557 12.2111C2.428 12.5499 2 13.2425 2 14H4ZM24 4L24.8944 2.21115C24.3314 1.92962 23.6686 1.92962 23.1056 2.21115L24 4ZM44 14H46C46 13.2425 45.572 12.5499 44.8944 12.2111L44 14ZM44 34L44.8944 35.7889C45.572 35.4501 46 34.7575 46 34H44ZM24 44L23.1056 45.7889C23.6686 46.0704 24.3314 46.0704 24.8944 45.7889L24 44ZM4 34H2C2 34.7575 2.428 35.4501 3.10557 35.7889L4 34ZM4.89443 15.7889L24.8944 5.78885L23.1056 2.21115L3.10557 12.2111L4.89443 15.7889ZM42 14V34H46V14H42ZM43.1056 32.2111L23.1056 42.2111L24.8944 45.7889L44.8944 35.7889L43.1056 32.2111ZM24.8944 42.2111L4.89443 32.2111L3.10557 35.7889L23.1056 45.7889L24.8944 42.2111ZM6 34V14H2V34H6ZM24.8944 25.7889L44.8944 15.7889L43.1056 12.2111L23.1056 22.2111L24.8944 25.7889ZM22 24V44H26V24H22ZM23.1056 5.78885L33.1056 10.7889L34.8944 7.21115L24.8944 2.21115L23.1056 5.78885ZM33.1056 10.7889L43.1056 15.7889L44.8944 12.2111L34.8944 7.21115L33.1056 10.7889ZM3.10557 15.7889L13.1056 20.7889L14.8944 17.2111L4.89443 12.2111L3.10557 15.7889ZM13.1056 20.7889L23.1056 25.7889L24.8944 22.2111L14.8944 17.2111L13.1056 20.7889ZM33.1056 7.21115L13.1056 17.2111L14.8944 20.7889L34.8944 10.7889L33.1056 7.21115Z",
    fill: props.outStrokeColor
  }));
});

exports.default = _default;